import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Header, Footer, Body } from '@calendly/ui/components/popup'
import { useDispatch, useSelector } from 'react-redux'

import { reactivateSubscription } from 'features/billing/actions/reactivate_subscription'
import { currentPeriodEndSelector } from 'features/billing/selectors'
import { useSmallDateFormat } from 'features/billing/stages/hooks/useDateFormat'

import { Paragraph, Error } from '../styles'
import { isFailureSelector, errorSelector } from './selectors'

export const NonRenewingModal = ({ onClose }) => {
  const dispatch = useDispatch()
  const currentPeriodEnd = useSmallDateFormat(useSelector(currentPeriodEndSelector))
  const isFailure = useSelector(isFailureSelector)
  const error = useSelector(errorSelector)

  const onRestore = () => {
    dispatch(reactivateSubscription())
  }

  return (
    <>
      <Header title={I18n.t('publisher.billing.scheduled_downgrade.non_renewing_modal.title')} />
      <Body>
        <Paragraph>
          {I18n.t('publisher.billing.scheduled_downgrade.non_renewing_modal.text1', { billing_end_date: currentPeriodEnd })}
        </Paragraph>
        <Paragraph>
          {HtmlParser(I18n.t('publisher.billing.scheduled_downgrade.non_renewing_modal.text2'))}
        </Paragraph>
        {
          isFailure && (
            <Error>
              {error}
            </Error>
          )
        }
      </Body>
      <Footer>
        <Button
          decoration="secondary-outline"
          onClick={onClose}
        >
          {I18n.t('publisher.action.cancel')}
        </Button>
        <Button onClick={onRestore}>
          {I18n.t('publisher.billing.scheduled_downgrade.non_renewing_modal.restore')}
        </Button>
      </Footer>
    </>
  )
}
